export default "__VITE_ASSET__DNfBFjr___"